import http from 'plugins/axios';

export default {
    addRecord(data) {
        return http.post({
            url: '/admin/sweep/add',
            data
        });
    },

    getAllRecord(data) {
        return http.get({
            url: '/admin/sweep/list',
            data
        });
    },

    sweepGasRatioConfig() {
        return http.get({
            url: '/admin/sweep/config/get_gasRatio',
        })
    },

    updateSweepGasRatioConfig(data) {
        return http.post({
            url: '/admin/sweep/config/update_gasRatio',
            data,
            dataType: 'form'
        })
    },

    retryRecord(data) {
        return http.post({
            url: '/admin/sweep/retry',
            data,
            dataType: 'form'
        })
    },

    getAllSupportCoin() {
        return http.get({
            url: '/admin/coin/allDisplay'
        });
    },
};
